import React from 'react';
import { Form, FormInstance, Input, Modal } from 'antd';
import { AttributeOptionsEditor } from './AttributeOptionsEditor';

interface EditAttributeModalProps {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
  form: FormInstance;
  onValuesChange: (changedValues: any, allValues: any) => void;
  loading?: boolean;
}

export const EditAttributeModal: React.FC<EditAttributeModalProps> = ({
  open,
  onCancel,
  onOk,
  form,
  onValuesChange,
  loading = false,
}) => {
  return (
    <Modal
      title="Редактировать атрибут"
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      confirmLoading={loading}
      afterClose={() => form.resetFields()}
      okText="Сохранить"
      cancelText="Отмена"
    >
      <Form
        form={form}
        layout="vertical"
        preserve={false}
        onValuesChange={onValuesChange}
      >
        <Form.Item
          label="Название"
          name="name"
          rules={[{ required: true, message: 'Введите название атрибута' }]}
        >
          <Input placeholder="Название атрибута" />
        </Form.Item>
        <Form.Item label="Описание" name="description">
          <Input.TextArea rows={3} placeholder="Описание атрибута" allowClear />
        </Form.Item>
        <Form.List name="options">
          {(fields, operations) => (
            <AttributeOptionsEditor
              fields={fields}
              operations={operations}
              helperText="Опции. Перетащите карточки, чтобы изменить порядок отображения."
              emptyText="Опции не заданы"
              listName={['options']}
            />
          )}
        </Form.List>
      </Form>
    </Modal>
  );
};